import React, { Component } from "react";
import {
  View,
  TouchableOpacity,
  Image,
  Dimensions,
  Pressable,
  ScrollView,
  TextInput,
  Linking,
} from "react-native";
import Checkbox from "expo-checkbox";
import MapView from "../map";
import * as Animatable from "react-native-animatable";
import { WHITE } from "react-native-material-color";
import { Dropdown } from "react-native-element-dropdown";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as Commons from "../utils/Commons";
import * as Constants from "../utils/Constants";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";
import Text from "../components/Text";
import * as ServerOperations from "../utils/ServerOperations";
import Marker from "../mapMarker";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 0;
let styles = {};
const chevronRight = require("../images/chevronRight.png");
const imgAddress = require("../images/ContactUs/location.png");
const imgPhoneNumber = require("../images/ContactUs/phone.png");
const imgEmail = require("../images/ContactUs/email.png");
const imgOpeningHours = require("../images/ContactUs/openingHours.png");
var faqsHeight = 0;
var faqsOpacity = 0;
var rotateChevron = '0deg';
let isMobile = false;
const dropDownListItems = [
  { value: 'NEW.BUSINESS', label: 'New Business' }, {
    value: 'NEW.COMPLAIN', label: 'Complaint'
  }
  , {
    value: 'OTHER', label: 'Other',
  }];


// const items = [
//   { label: 'Option 1', value: '1' },
//   { label: 'Option 2', value: '2' },
// ];

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isScrolled: false,
      isVideoPlaying: false,
      brands: [],
      commonResponse: [],
      joImgPos: 0,
      hideScrollTopButton: true,
      selectedCommonPos: 0,
      sendingEmail: [],
      userEmail: "",
      emailContent: "",
      emailName: "",
      emailSubject: "",
      agree: false,
    };
  }
  Pressables = {};


  async componentDidMount() {
    const commonResponse = await ServerOperations.getCommonFAQs();
    // const sendingEmail = await ServerOperations.sendEmail();
    this.setState({ commonResponse });
    this.setState({ sendingEmail: false });
  }


  renderPressableButton = (componentRef, text, onPress) => {
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    if (this.state.agree == false) {
      var submitStyle = Styles.ContactUsSubmitButton;
      var submitTextStyle = Styles.SubmitButtonTextStyle;
    } else {
      submitStyle = Styles.ButtonStyle2;
      submitTextStyle = Styles.ButtonTextStyle;
    }
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })}>
        <TouchableOpacity onPress={onPress} style={isHovered ? Styles.GetInTouchHoveredButton : submitStyle} disabled={!this.state.agree}>
          <Text style={isHovered ? Styles.ButtonTextStyleHovered : submitTextStyle}>{text}</Text>
        </TouchableOpacity>
      </Pressable>
    )
  }


  renderPressableLink = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    return (
      <View style={{ gap: 15 }}>
        <Pressable
          ref={el => (this.Pressables[componentRef] = el)}>
          <TouchableOpacity onPress={() => {
            this.commonFAQsStyle();
            this.Pressables[`${componentRef}_image`].animate({ 0: { transform: [{ rotate: '0deg' }] }, 1: { transform: [{ rotate: rotateChevron }] } }, 150)
            onPress();
          }} style={{
            flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "flex-start", gap: 8,
          }}>
            <Text style={[Styles.TextStyle2, textStyle, {
              fontSize: 24,
              color: '#52C0EE',
            }]}>{text}</Text>
            <Animatable.Image
              ref={el => (this.Pressables[`${componentRef}_image`] = el)}
              source={isHovered ? chevronRight : chevronRight} style={{ height: 32, width: 32, marginBottom: -2, transform: [{ rotate: rotateChevron }] }} resizeMode="contain" />
          </TouchableOpacity>
        </Pressable>
        {/* <View style={{ width: 301, border: '2px solid transparent', borderBottomColor: Styles.appColor1 }}></View> */}
      </View>
    )
  }

  commonFAQsStyle = () => {
    if (faqsHeight == 0) {
      faqsHeight = 30;
      faqsOpacity = 1;
      this.CommonAnswerView.animate({ 0: { height: 0, opacity: 0 }, 1: { height: faqsHeight, opacity: faqsOpacity } }, 1000);
      rotateChevron = '90deg';
    } else {
      faqsHeight = 0;
      faqsOpacity = 0;
      this.CommonAnswerView.animate({ 0: { height: 0, opacity: 0 }, 1: { height: faqsHeight, opacity: faqsOpacity } }, 2000);
      rotateChevron = '0deg';
    }

  }


  sendEmail = async () => {
    this.setState({ errorMessage: undefined })
    if (!this.state.emailName) {
      this.setState({ errorMessage: '* Insert Name' })
      return;
    }
    if (!this.state.userEmail) {
      this.setState({ errorMessage: '* Insert Email' })
      return;
    }

    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!re.test(this.state.userEmail)) {
      this.setState({ errorMessage: '* Insert Correct Email Format' })
      return;
    }

    if (!this.state.emailSubject) {
      this.setState({ errorMessage: '* Insert Category' })
      return;
    }
    if (!this.state.emailContent) {
      this.setState({ errorMessage: '* Insert Message' })
      return;
    }
    // Sanitize email content to prevent XSS and other security issues
    const sanitizeInput = (input) => {
      if (!input) return '';
      return input
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '') // Remove script tags
        .replace(/<[^>]*>/g, '') // Remove HTML tags
        .replace(/javascript:/gi, '') // Remove javascript: protocol
        .replace(/on\w+\s*=/gi, '') // Remove event handlers
        .trim();
    };

    const sanitizedEmailContent = sanitizeInput(this.state.emailContent);
    const sanitizedEmailName = sanitizeInput(this.state.emailName);
    const sanitizedEmailSubject = sanitizeInput(this.state.emailSubject);
    ServerOperations.sendEmail(sanitizedEmailName, this.state.userEmail, sanitizedEmailSubject, sanitizedEmailContent);
    // alert('Message sent Successfully');
    this.setState({ sent: true })
  }



  renderMobile = () => {
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={""}
        />
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
          {Commons.loadFonts(this)}
          <View style={{ width, paddingHorizontal: 20, gap: 50, textAlign: 'center' }}>
            {Styles.renderVSeparator(100)}
            {this.renderPart1Mobile()}
            {this.renderPart2Mobile()}
            {this.renderPart3Mobile()}
            {/* {this.renderPart4Mobile()} */}
            {/* {Styles.renderVSeparator(0)} */}
          </View>
          {Commons.renderFooter({}, this)}
        </ScrollView >
      </View>

    );
  }


  render() {
    Commons.resizeHandle(window, this, () => {
      width = this.width;
      height = this.height;
    });
    width = Dimensions.get("window").width;
    isMobile = Commons.isMobile();
    if (isMobile) {
      styles = this.styles();
      return this.renderMobile();
    }
    width = Commons.getWidth();
    styles = this.styles();
    marginTop = 300;
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={"Contact Us"}
        />
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
          {Commons.loadFonts(this)}
          {this.renderPart1()}
          {this.renderPart2()}
          {this.renderPart4()}
          {Commons.renderFooter({}, this)}
        </ScrollView >

      </View >
    );
  }


  renderPart1Mobile() {
    return (
      <View style={{ textAlign: 'left', gap: 30 }}>
        <Text style={[Styles.TextStyle3, {}]}>{STRINGS.contact_us}</Text>
        <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
          We appreciate your interest and are here to assist with any inquiries you might have!
        </Text>
      </View>
    )
  }

  renderPart1 = () => {
    var marginLeft = 164;
    return (
      <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 19, paddingTop: 200, paddingLeft: marginLeft }}>
        <Text style={[Styles.TextStyle1, { fontSize: 43.95 }]}>{STRINGS.contact_us}</Text>
        <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
          We appreciate your interest and are here to assist with any
          {'\n'}inquiries you might have!
        </Text>
      </View>
    )
  }


  renderPart3Mobile = () => {
    var inputWidth = width - 100;
    var checkBoxWidth = width - 790.882;
    if (checkBoxWidth < 700) {
      checkBoxWidth = 500;
    }
    let scale = width / 420;
    if (scale > 1.1) scale = 1.1;
    const buttonStyle = {
      display: 'flex',
      width: 183 * scale,
      height: 87.5,
      padding: 20,
      alignItems: 'center',
      gap: 15,
      borderRadius: '50px',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: Styles.appColor1,
      flexDirection: "row",
    }

    const fontSize = 10 * scale;
    return (
      <View style={{
        display: 'inline-flex',
        flexDirection: "column",
        alignItems: 'flex-start',
        gap: 20,
        marginTop: 50,
        textAlign: 'left'
      }}>
        <Text style={[Styles.TextStyle1, { fontSize: 28 }]}>Contact Details</Text>
        <Text style={[Styles.TextStyle1, { fontSize: 24 }]}>Headquarters Offices</Text>

        <View style={{ flexDirection: 'row', gap: 20 }}>
          <TouchableOpacity onPress={() => {
            Linking.openURL('https://maps.google.com?q=31.970068,35.903867')
          }} style={buttonStyle}>
            <Image style={{ width: 23, height: 29, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgAddress}></Image>

            <View style={{ flexDirection: 'column' }}>
              <Text style={[Styles.TextStyle2, { fontSize, fontWeight: '700', alignSelf: 'stretch' }]}>Address</Text>
              <Text style={[Styles.TextStyle2, { fontSize }]}>Issam Al-Ajlouni St. 48,{'\n'}Amman, Jordan</Text>

            </View>
          </TouchableOpacity>

          <TouchableOpacity style={buttonStyle} onPress={() => {
            window.location.href = `tel:+962 6 566 5125`;
          }}>
            <Image style={{ width: 24.311, height: 25.674, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgPhoneNumber}></Image>

            <View style={{ flexDirection: 'column' }}>
              <Text style={[Styles.TextStyle2, { fontWeight: '700', alignSelf: 'stretch', fontSize }]}>Phone Number</Text>
              <Text style={[Styles.TextStyle2, { fontSize }]}>+962 6 566 5125</Text>

            </View>
          </TouchableOpacity>
        </View>


        {/* {second row} */}
        <View style={{ flexDirection: 'row', gap: 20 }}>
          <TouchableOpacity onPress={() => {
            window.location.href = `mailto:jds@jdsco.net`;
          }} style={buttonStyle}>
            <Image style={{ width: 26.666, height: 19, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgEmail}></Image>

            <View style={{ flexDirection: 'column' }}>
              <Text style={[Styles.TextStyle2, { fontWeight: '700', alignSelf: 'stretch', fontSize }]}>Email</Text>
              <Text style={[Styles.TextStyle2, { fontSize }]}>jds@jdsco.net</Text>
            </View>
          </TouchableOpacity>

          <View style={buttonStyle}>
            <Image style={{ width: 25, height: 25, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgOpeningHours}></Image>
            <View style={{ flexDirection: 'column' }}>
              <Text style={[Styles.TextStyle2, { fontWeight: '700', alignSelf: 'stretch', fontSize }]}>Opening Hours</Text>
              <Text style={[Styles.TextStyle2, { fontSize }]}>8AM - 4PM (GMT+3)</Text>
            </View>
          </View>
        </View>

        <Text style={[Styles.TextStyle1, { fontSize: 24 }]}>Warehouse</Text>

        {/* {third row} */}
        <View style={{ flexDirection: 'row', gap: 20 }}>
          <TouchableOpacity onPress={() => {
            Linking.openURL('https://maps.google.com?q=31.8642423,35.980298');
          }} style={buttonStyle}>
            <Image style={{ width: 23, height: 29, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgAddress}></Image>
            <View style={{ flexDirection: 'column' }}>
              <Text style={[Styles.TextStyle2, { fontWeight: '700', alignSelf: 'stretch', fontSize }]}>Address</Text>
              <Text style={[Styles.TextStyle2, { fontSize }]}>Al Tajamouat Industrial{'\n'}City, Bldg (N), Sahab,{'\n'}Jordan</Text>
            </View>
          </TouchableOpacity>

          <TouchableOpacity onPress={() => {
            window.location.href = `tel:+962 6 402 2350`;
          }} style={buttonStyle}>
            <Image style={{ width: 24.311, height: 25.674, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgPhoneNumber}></Image>

            <View style={{ flexDirection: 'column' }}>
              <Text style={[Styles.TextStyle2, { fontWeight: '700', alignSelf: 'stretch', fontSize }]}>Phone Number</Text>
              <Text style={[Styles.TextStyle2, { fontSize }]}>+962 6 402 2350</Text>

            </View>
          </TouchableOpacity>
        </View>

        <View style={{ width: width, height: 256 * scale, marginLeft: -20, flexShrink: 0, marginVertical: 50 }}>
          <MapView googleMapsApiKey={"AIzaSyAsZsz6Yh4G_88061k71jnfLOMgTxw5YUM"}
            provider="google"
            minZoomLevel={10}
            initialRegion={{
              latitude: 31.9700749,
              longitude: 35.9012898,
              latitudeDelta: 0.00595,
              longitudeDelta: 0.007,
            }}
          >

            <Marker
              key="address-marker1"
              coordinate={{
                latitude: 31.970068,
                longitude: 35.903867
              }}
              title="Headquarters Offices"
              description="Headquarters Offices"
            />
            <Marker
              key="address-marker1"
              coordinate={{
                latitude: 31.8642423,
                longitude: 35.980298
              }}
              title="Warehouse"
              description="Warehouse"
            />
          </MapView>
        </View>
      </View>
    )
  }

  renderPart2Mobile = () => {
    var inputWidth = width - 100;
    var checkBoxWidth = width - 790.882;
    if (checkBoxWidth < 700) {
      checkBoxWidth = 500;
    }
    return (
      <View style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 20,
        width: width - 40,
        paddingVertical: 50,
        paddingHorizontal: 30,
        backgroundColor: '#eaeaea'
      }}>
        <View style={{ display: 'flex', width: width - 40, flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
          <Text style={[Styles.TextStyle3]}>
            Get In Touch With Us
          </Text>
          <Text style={[Styles.TextStyle2, { fontSize: 16, color: 'red', marginTop: 20 }]}>
            *
            <Text style={[Styles.TextStyle2]}>Name</Text>
          </Text>
          <TextInput style={{
            height: 40,
            borderWidth: 1,
            width: inputWidth,
            height: 53.647,
            borderRadius: 30,
            borderColor: Styles.appColor4,
            backgroundColor: 'white',
            textAlign: 'flex-start',
            paddingLeft: 10,
            fontSize: 18,
          }}
            onChangeText={(text) => this.setState({ emailName: text })}
            value={this.state.emailName} />
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
          <Text style={[Styles.TextStyle2, { fontSize: 16, color: 'red' }]}>
            *
            <Text style={[Styles.TextStyle2]}>Email</Text>
          </Text>
          <TextInput style={{
            height: 40,
            // margin: 12,
            borderWidth: 1,
            width: inputWidth,
            height: 53.647,
            borderRadius: 30,
            borderColor: Styles.appColor4,
            backgroundColor: 'white',
            textAlign: 'flex-start',
            paddingLeft: 10,
            fontSize: 18,
          }}
            onChangeText={(text) => this.setState({ userEmail: text })}
            value={this.state.userEmail} />
        </View>

        <View style={{ display: 'flex', width: 597, flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
          <Text style={[Styles.TextStyle2, { fontSize: 16, color: 'red' }]}>
            *
            <Text style={[Styles.TextStyle2]}>Choose A Category</Text>
          </Text>
          <View style={{
            width: inputWidth, borderRadius: 30,
            borderColor: Styles.appColor4,
            backgroundColor: 'white',
            borderWidth: 1
          }}>
            <Dropdown style={{ width: inputWidth - 10, height: 53, marginLeft: 1, paddingLeft: 10 }}
              inputSearchStyle={styles.inputSearchStyle}
              searchPlaceholder="Search..."
              search
              labelField="label"
              valueField="value"
              placeholder=""
              value={this.state.emailSubject}
              data={dropDownListItems}
              // renderItem={dropDownListItems}
              onChange={(text) => this.setState({ emailSubject: (text.value) })}
            />
          </View>
        </View>

        <View style={{ display: 'flex', width: 597, flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
          <Text style={[Styles.TextStyle2, { fontSize: 16, color: 'red' }]}>
            *
            <Text style={[Styles.TextStyle2]}>Message</Text>
          </Text>
          <TextInput style={{
            height: 114,
            width: inputWidth,
            borderWidth: 1,
            borderColor: Styles.appColor4,
            backgroundColor: 'white',
            // margin: 12,
            borderRadius: 30,
            textAlign: 'flex-start',
            paddingLeft: 10,
            paddingTop: 10,
            fontSize: 18
          }}
            editable={true}
            multiline={true}
            onChangeText={(text) => this.setState({ emailContent: text })}
            value={this.state.emailContent}
          />
        </View>

        <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 8, textAlign: 'left' }}>
          <Checkbox style={{ alignSelf: 'center' }}
            value={this.state.agree}
            onValueChange={(agree) => { this.setState({ agree }) }}
            color={this.state.agree ? "#4630EB" : undefined} />
          <Text style={[Styles.TextStyle2, { fontSize: 11.52, color: 'red' }]}>
            *
            <Text style={[Styles.TextStyle2, { fontSize: 11.52 }]}>
              I hereby grant permission to Jordan Drugstore Co. and its affiliated entities for the collection and processing of my personal information in
              alignment with the Regional Privacy Policy.
            </Text>
          </Text>
        </View>
        <Pressable disabled={!this.state.agree}>
          {this.renderPressableButton('SubmitButton', 'Submit', () => this.sendEmail())}
        </Pressable>
        {this.state.sent && <Text style={[Styles.TextStyle2, { color: '#4D7F3B' }]}> ✓ You’ve successfully submitted your message </Text>}
        {this.state.errorMessage && <Text style={[Styles.TextStyle2, { color: 'darkred' }]}> {this.state.errorMessage} </Text>}
      </View>
    )
  }

  renderPart2 = () => {

    var inputWidth = width - 1000;
    var marginLeft = 160;
    if (inputWidth < 445) {
      inputWidth = 445;
    }
    var checkBoxWidth = width - 790.882;
    if (checkBoxWidth < 700) {
      checkBoxWidth = 500;
    }
    return (
      <View style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 83,
        marginTop: marginTop - 250,
        width,
        paddingLeft: marginLeft,
      }}>
        <View style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 20,
          // marginTop: marginTop - 250,
          width: 505,
          paddingVertical: 50,
          // paddingLeft: marginLeft,
          paddingHorizontal: 30,
          backgroundColor: '#eaeaea'
        }}>
          <View style={{ display: 'flex', width: 505, flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
            <Text style={[Styles.TextStyle1, { fontSize: 28 }]}>
              Get In Touch With Us
            </Text>
            <Text style={[Styles.TextStyle2, { fontSize: 16, color: 'red', marginTop: 20 }]}>
              *
              <Text style={[Styles.TextStyle2]}>Name</Text>
            </Text>
            <TextInput style={{
              height: 40,
              // margin: 12,
              borderWidth: 1,
              width: inputWidth,
              height: 53.647,
              borderRadius: 30,
              borderColor: Styles.appColor4,
              backgroundColor: 'white',
              textAlign: 'flex-start',
              paddingLeft: 10,
              fontSize: 18,
            }}
              onChangeText={(text) => this.setState({ emailName: text })}
              value={this.state.emailName} />
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
            <Text style={[Styles.TextStyle2, { fontSize: 16, color: 'red' }]}>
              *
              <Text style={[Styles.TextStyle2]}>Email</Text>
            </Text>
            <TextInput style={{
              height: 40,
              // margin: 12,
              borderWidth: 1,
              width: inputWidth,
              height: 53.647,
              borderRadius: 30,
              borderColor: Styles.appColor4,
              backgroundColor: 'white',
              textAlign: 'flex-start',
              paddingLeft: 10,
              fontSize: 18,
            }}
              onChangeText={(text) => this.setState({ userEmail: text })}
              value={this.state.userEmail} />
          </View>

          <View style={{ display: 'flex', width: 597, flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
            <Text style={[Styles.TextStyle2, { fontSize: 16, color: 'red' }]}>
              *
              <Text style={[Styles.TextStyle2]}>Choose A Category</Text>
            </Text>
            <View style={{
              width: inputWidth, borderRadius: 30,
              borderColor: Styles.appColor4,
              backgroundColor: 'white',
              borderWidth: 1
            }}>
              <Dropdown style={{ width: inputWidth - 10, height: 53, marginLeft: 1, paddingLeft: 10 }}
                inputSearchStyle={styles.inputSearchStyle}
                searchPlaceholder="Search..."
                search
                labelField="label"
                valueField="value"
                placeholder=""
                value={this.state.emailSubject}
                data={dropDownListItems}
                // renderItem={dropDownListItems}
                onChange={(text) => this.setState({ emailSubject: (text.value) })}
              />
            </View>
          </View>

          <View style={{ display: 'flex', width: 597, flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
            <Text style={[Styles.TextStyle2, { fontSize: 16, color: 'red' }]}>
              *
              <Text style={[Styles.TextStyle2]}>Message</Text>
            </Text>
            <TextInput style={{
              height: 232.47,
              width: inputWidth,
              borderWidth: 1,
              borderColor: Styles.appColor4,
              backgroundColor: 'white',
              // margin: 12,
              borderRadius: 30,
              textAlign: 'flex-start',
              paddingLeft: 10,
              paddingTop: 10,
              fontSize: 18
            }}
              editable={true}
              multiline={true}
              onChangeText={(text) => this.setState({ emailContent: text })}
              value={this.state.emailContent}
            />
          </View>

          <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 8 }}>
            <Checkbox style={{ alignSelf: 'center' }}
              value={this.state.agree}
              onValueChange={(agree) => { this.setState({ agree }) }}
              color={this.state.agree ? "#4630EB" : undefined} />
            <Text style={[Styles.TextStyle2, { fontSize: 11.52, color: 'red' }]}>
              *
              <Text style={[Styles.TextStyle2, { fontSize: 11.52 }]}>
                I hereby grant permission to Jordan Drugstore Co. and its affiliated entities for the {'\n'}collection and processing of my personal information in
                alignment with the Regional{'\n'}Privacy Policy.
              </Text>
            </Text>
          </View>
          <Pressable disabled={!this.state.agree}>
            {this.renderPressableButton('SubmitButton', 'Submit', () => this.sendEmail())}
          </Pressable>
          {this.state.sent && <Text style={[Styles.TextStyle2, { color: '#4D7F3B' }]}> ✓ You’ve successfully submitted your message </Text>}
          {this.state.errorMessage && <Text style={[Styles.TextStyle2, { color: 'darkred' }]}> {this.state.errorMessage} </Text>}
        </View>

        <View style={{
          display: 'inline-flex',
          // padding:50,
          flexDirection: "column",
          alignItems: 'flex-start',
          gap: 20,
          marginTop: 50
        }}>
          <Text style={[Styles.TextStyle1, { fontSize: 28 }]}>Contact Details</Text>
          <Text style={[Styles.TextStyle1, { fontSize: 24 }]}>Headquarters Offices</Text>

          <View style={{ flexDirection: 'row', gap: 20 }}>
            <TouchableOpacity onPress={() => {
              Linking.openURL('https://maps.google.com?q=31.970068,35.903867')
            }} style={{
              display: 'flex',
              width: 238,
              height: 114,
              padding: 20,
              alignItems: 'center',
              gap: 20,
              borderRadius: '50px',
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: Styles.appColor1,
              flexDirection: "row",
            }}>
              <Image style={{ width: 30, height: 38, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgAddress}></Image>

              <View style={{ flexDirection: 'column' }}>
                <Text style={[Styles.TextStyle2, { fontWeight: '700', alignSelf: 'stretch' }]}>Address</Text>
                <Text style={[Styles.TextStyle2, { fontSize: 14 }]}>Issam Al-Ajlouni St. 48,{'\n'}Amman, Jordan</Text>

              </View>
            </TouchableOpacity>

            <TouchableOpacity onPress={() => {
              window.location.href = `tel:+962 6 566 5125`;
            }} style={{
              display: 'flex',
              width: 238,
              height: 114,
              padding: 20,
              alignItems: 'center',
              gap: 20,
              borderRadius: '50px',
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: Styles.appColor1,
              flexDirection: "row",
            }}>
              <Image style={{ width: 32.311, height: 32.674, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgPhoneNumber}></Image>

              <TouchableOpacity onPress={() => {
                window.location.href = `tel:+962 6 566 5125`;
              }} style={{ flexDirection: 'column' }}>
                <Text style={[Styles.TextStyle2, { fontWeight: '700', alignSelf: 'stretch' }]}>Phone Number</Text>
                <Text style={[Styles.TextStyle2, { fontSize: 14 }]}>+962 6 566 5125</Text>

              </TouchableOpacity>
            </TouchableOpacity>
          </View>


          {/* {second row} */}
          <View style={{ flexDirection: 'row', gap: 20 }}>
            <TouchableOpacity onPress={() => {
              window.location.href = `mailto:jds@jdsco.net`;
            }} style={{
              display: 'flex',
              width: 238,
              height: 114,
              padding: 20,
              alignItems: 'center',
              gap: 20,
              borderRadius: '50px',
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: Styles.appColor1,
              flexDirection: "row",
            }}>
              <Image style={{ width: 34.666, height: 26, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgEmail}></Image>

              <View style={{ flexDirection: 'column' }}>
                <Text style={[Styles.TextStyle2, { fontWeight: '700', alignSelf: 'stretch' }]}>Email</Text>
                <Text style={[Styles.TextStyle2, { fontSize: 14 }]}>jds@jdsco.net</Text>

              </View>
            </TouchableOpacity>

            <View style={{
              display: 'flex',
              width: 238,
              height: 114,
              padding: 20,
              alignItems: 'center',
              gap: 20,
              borderRadius: '50px',
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: Styles.appColor1,
              flexDirection: "row",
            }}>
              <Image style={{ width: 32.8, height: 32.8, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgOpeningHours}></Image>

              <View style={{ flexDirection: 'column' }}>
                <Text style={[Styles.TextStyle2, { fontWeight: '700', alignSelf: 'stretch' }]}>Opening Hours</Text>
                <Text style={[Styles.TextStyle2, { fontSize: 14 }]}>8AM - 4PM (GMT+3)</Text>

              </View>
            </View>
          </View>

          <Text style={[Styles.TextStyle1, { fontSize: 24 }]}>Warehouse</Text>

          {/* {third row} */}
          <View style={{ flexDirection: 'row', gap: 20 }}>
            <TouchableOpacity onPress={() => {
              Linking.openURL('https://maps.google.com?q=31.8642423,35.980298');
            }} style={{
              display: 'flex',
              width: 238,
              height: 114,
              padding: 20,
              alignItems: 'center',
              gap: 20,
              borderRadius: '50px',
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: Styles.appColor1,
              flexDirection: "row",
            }}>
              <Image style={{ width: 30, height: 38, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgAddress}></Image>

              <View style={{ flexDirection: 'column' }}>
                <Text style={[Styles.TextStyle2, { fontWeight: '700', alignSelf: 'stretch' }]}>Address</Text>
                <Text style={[Styles.TextStyle2, { fontSize: 14 }]}>Al Tajamouat Industrial{'\n'}City, Bldg (N), Sahab,{'\n'}Jordan</Text>

              </View>
            </TouchableOpacity>

            <TouchableOpacity onPress={() => {
              window.location.href = `tel:+962 6 402 2350`;
            }} style={{
              display: 'flex',
              width: 238,
              height: 114,
              padding: 20,
              alignItems: 'center',
              gap: 20,
              borderRadius: '50px',
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: Styles.appColor1,
              flexDirection: "row",
            }}>
              <Image style={{ width: 32.311, height: 32.674, flexShrink: 0, tintColor: Styles.appColor1 }} source={imgPhoneNumber}></Image>

              <View style={{ flexDirection: 'column' }}>
                <Text style={[Styles.TextStyle2, { fontWeight: '700', alignSelf: 'stretch' }]}>Phone Number</Text>
                <Text style={[Styles.TextStyle2, { fontSize: 14 }]}>+962 6 402 2350</Text>

              </View>
            </TouchableOpacity>
          </View>

          <View style={{ width: 521, height: 278, flexShrink: 0, marginTop: 20 }}>
            <MapView googleMapsApiKey={"AIzaSyAsZsz6Yh4G_88061k71jnfLOMgTxw5YUM"}
              provider="google"
              minZoomLevel={10}
              initialRegion={{
                latitude: 31.9700749,
                longitude: 35.9012898,
                latitudeDelta: 0.00595,
                longitudeDelta: 0.007,
              }}
            >

              <Marker
                key="address-marker1"
                coordinate={{
                  latitude: 31.970068,
                  longitude: 35.903867
                }}
                title="Headquarters Offices"
                description="Headquarters Offices"
              />
              <Marker
                key="address-marker1"
                coordinate={{
                  latitude: 31.8642423,
                  longitude: 35.980298
                }}
                title="Warehouse"
                description="Warehouse"
              />
            </MapView>
          </View>
        </View>
      </View>
    )
  }



  renderPart3 = () => {
    const commonItems = this.state.commonResponse.map(
      (item, index) => {
        const isSelected = this.state.selectedCommonPos == index;
        return (
          <View style={{ gap: 10 }}>
            {this.renderPressableLink(item.QUESTION, { letterSpacing: 1.25 }, () => this.setState({ selectedCommonPos: index }))}
            {
              isSelected &&
              <Animatable.View
                nativeID={index}
                style={{ alignItems: 'flex-start' }}>
                <Animatable.Text
                  ref={el => this.CommonAnswerView = el}
                  style={[Styles.TextStyle2, { fontSize: 18, color: '#52C0EE', height: faqsHeight, opacity: faqsOpacity, }]}>{item.ANSWER}</Animatable.Text>
              </Animatable.View>
            }
            <View style={{ width: 301, border: '2px solid transparent', borderBottomColor: Styles.appColor1 }}></View>
          </View>
        )
      }
    );
    var marginLeft = 164;
    return (<View style={{
      width,
      marginTop: marginTop - 150,
      flexDirection: 'column',
      gap: 83,
      backgroundColor: '#FFF',
      paddingLeft: marginLeft,
    }}>
      <Text style={[Styles.TextStyle1, { fontSize: 35.16 }]}>Common FAQs</Text>
      <View style={{
        display: 'flex',
        width: 744,
        // marginLeft: 15,
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 16,
        borderRadius: 16,
        boxShadow: '0px 49.745px 62.182px 0px rgba(0, 0, 0, 0.10), 0px 24.873px 24.873px 0px rgba(0, 0, 0, 0.04)'
      }}>
        <View style={{ paddingLeft: 80, paddingTop: 80, paddingRight: 80, paddingBottom: 120, flexDirection: 'column', gap: 16 }}>
          {commonItems}
        </View>
      </View>
    </View>)
  }


  renderPart4 = () => {
    return (<View style={{
      height: 150,
    }}>

    </View>

    )
  }




  onBrandScroll = (e) => {
    const endReached =
      parseInt(e.nativeEvent.contentOffset.x) +
      parseInt(e.nativeEvent.layoutMeasurement.width) -
      parseInt(e.nativeEvent.contentSize.width) ==
      0;
    const startReached = e.nativeEvent.contentOffset.x == 0;
    if (endReached) {
      // this.brandsView.scrollTo({ animated: true, x: 0 });
    } else if (startReached) {
    }
  };

  styles = () => ({
    container: {
      flex: 1,
      paddingVertical: 0,
      paddingHorizontal: 164,
      alignItems: "center",
      gap: 100,
      backgroundColor: WHITE
    },
    image: {
      flex: 1,
      resizeMode: 'contain',
      justifyContent: 'center',
      width,
      height: width * 0.46,
    },

    inputSearchStyle: {
      height: 40,
      fontSize: 16,
    },
    item: {
      padding: 17,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    textItem: {
      flex: 1,
      fontSize: 16,
      color: '#000',
    },

  });
}



export default ContactUs;
